import { z } from 'zod';

const channelSchema = z.object({
  label: z.string().min(1),
  href: z.string().min(1),
  newTab: z.boolean().optional(),
});

const contactCardSchema = z.object({
  description: z.string().min(1),
  channels: z.array(channelSchema).min(1),
});

export const supportSchema = z.object({
  placeholder: z.boolean(),
  support: contactCardSchema,
  careers: contactCardSchema,
});

export type Support = z.infer<typeof supportSchema>;
